// Eligibility Status names whose ES Note text is data-driven rather than fixed by the status name
// alone: "No OON Benefits" depends on the primary active insurance, and "Non-Billable Insurance"
// depends on the Insurance Info Note. See ISG-2586.
export const EligibilityStatusName = {
    NoOonBenefits: "No OON Benefits",
    NonBillableInsurance: "Non-Billable Insurance",
};
